import { authState, signIn, signOut } from "@/auth/store";
import { LangToggle } from "@/components/LangToggle";
import { t } from "@/i18n";

// Auth gate landing screen. Two states: signed out (offer Google sign-in) and
// forbidden (authenticated Google account without the admin:true claim).
export function Login() {
  const s = authState.value;
  const forbidden = s.status === "forbidden";

  return (
    <div class="login-screen">
      <div class="login-card">
        <div class="brand">
          gateway<b>.one</b>
        </div>
        <h1>{t("login.title")}</h1>

        {forbidden ? (
          <>
            <p class="login-msg">
              {s.user?.email ? <strong>{s.user.email}</strong> : t("login.thisAccount")}
              {t("login.forbiddenSuffix")}
            </p>
            <p class="login-hint">{t("login.forbiddenHint")}</p>
            <button class="login-btn" onClick={() => void signOut()}>
              {t("header.signOut")}
            </button>
          </>
        ) : (
          <>
            <p class="login-msg">{t("login.signInMsg")}</p>
            {s.error && (
              <p class="login-error" role="alert">
                {s.error}
              </p>
            )}
            <button class="login-btn" onClick={() => void signIn()}>
              {t("login.signInGoogle")}
            </button>
          </>
        )}
        <div style="display: flex; justify-content: center; margin-top: var(--space-5);">
          <LangToggle />
        </div>
      </div>
    </div>
  );
}
